module.exports = __webpack_public_path__ + "static/media/Developmenticon07.a9bf696a.png";